
import {
  saveTaskPosition
} from '@/common/apiGeneral.js';
import { getCurrentPosition } from '../common/getCurrentPosition';
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {
      isFirstLoad: true
    };
  },
  computed: {
    ...mapState('orderGeneral', {
      timer: state => state.getPositionTimer
    })
  },
  mounted() {
    if (this.isFirstLoad) {
      this.getCurrentPosition();
    }
    this.setTimer();
  },
  activated() {
    if (!this.isFirstLoad) {
      this.getCurrentPosition();
    }
    this.setTimer();
  },
  methods: {
    ...mapActions('orderGeneral', ['setCurrentPosition', 'setGetPositionTimer']),
    // 获取当前位置
    async getCurrentPosition() {
      try {
        const currentPosition = await getCurrentPosition();
        this.setCurrentPosition(currentPosition);
        this.saveTaskPosition(currentPosition);
      } catch (error) {
        console.log(error);
      }
    },
    // 保存用户数据
    async saveTaskPosition(currentPosition) {
      await saveTaskPosition({
        source: '1', // H5传1
        ...currentPosition
      });
      if (this.isFirstLoad) {
        window.setTimeout(() => { this.isFirstLoad = false; }, 1000);
      }
    },
    setTimer() {
      this.clearTimer();
      console.log('初始化计时器');
      const timer = window.setTimeout(() => {
        console.log('计时器运行');
        this.getCurrentPosition();
        this.setTimer();
      }, 5000);
      this.setGetPositionTimer(timer);
    },
    clearTimer() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.setGetPositionTimer(null);
      }
    }
  }

};
